import { gql } from "@shared/utils";

// Fragment for message fields
export const PROJECT_MESSAGE_FIELDS = gql`
  fragment ProjectMessageFields on ProjectMessage {
    _id
    projectId
    userId
    content
    attachments {
      key
      filename
      contentType
      size
      url
    }
    replyToId
    reactions {
      emoji
      userIds
    }
    editedAt
    deleted
    createdAt
  }
`;

// Queries
export const PROJECT_MESSAGES_QUERY = gql`
  ${PROJECT_MESSAGE_FIELDS}
  query ProjectMessages($projectId: String!, $limit: Int, $before: String) {
    projectMessages(projectId: $projectId, limit: $limit, before: $before) {
      ...ProjectMessageFields
    }
  }
`;

export const PROJECT_UNREAD_COUNT_QUERY = gql`
  query ProjectUnreadCount($projectId: String!) {
    projectUnreadCount(projectId: $projectId)
  }
`;

export const PROJECTS_UNREAD_COUNTS_QUERY = gql`
  query ProjectsUnreadCounts($projectIds: [String!]!) {
    projectsUnreadCounts(projectIds: $projectIds) {
      projectId
      unreadCount
    }
  }
`;

export const USERS_QUERY = gql`
  query GetAllUsersForChat {
    users {
      _id
      auth0_id
      first_name
      last_name
      email
    }
  }
`;

// Mutations - Note: mutations use input wrapper objects
export const SEND_PROJECT_MESSAGE_MUTATION = gql`
  ${PROJECT_MESSAGE_FIELDS}
  mutation SendProjectMessage($input: SendProjectMessageInput!) {
    sendProjectMessage(input: $input) {
      ...ProjectMessageFields
    }
  }
`;

export const EDIT_PROJECT_MESSAGE_MUTATION = gql`
  ${PROJECT_MESSAGE_FIELDS}
  mutation EditProjectMessage($input: EditProjectMessageInput!) {
    editProjectMessage(input: $input) {
      ...ProjectMessageFields
    }
  }
`;

export const DELETE_PROJECT_MESSAGE_MUTATION = gql`
  mutation DeleteProjectMessage($input: DeleteProjectMessageInput!) {
    deleteProjectMessage(input: $input)
  }
`;

export const TOGGLE_MESSAGE_REACTION_MUTATION = gql`
  ${PROJECT_MESSAGE_FIELDS}
  mutation ToggleMessageReaction($input: ToggleMessageReactionInput!) {
    toggleMessageReaction(input: $input) {
      ...ProjectMessageFields
    }
  }
`;

export const MARK_PROJECT_READ_MUTATION = gql`
  mutation MarkProjectRead($input: MarkProjectReadInput!) {
    markProjectRead(input: $input)
  }
`;

export const GET_PROJECT_FILE_UPLOAD_URL_MUTATION = gql`
  mutation GetProjectFileUploadUrl($input: GetProjectFileUploadUrlInput!) {
    getProjectFileUploadUrl(input: $input) {
      uploadUrl
      key
    }
  }
`;
